import React from 'react'
import { Moon, Sun } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { tr } from 'i18n'
import { useAppTheme } from './ThemeProvider'

export default function ThemeToggle({ compact = false, className = '' }) {
  const { theme, toggleTheme } = useAppTheme()
  useTranslation()
  const dark = theme === 'dark'
  const label = tr(dark ? 'Светлая тема' : 'Тёмная тема')
  return <button type="button" className={`theme-toggle ${compact ? 'theme-toggle--compact' : ''} ${className}`} onClick={toggleTheme} title={label} aria-label={label} aria-pressed={dark}>
    {dark ? <Sun size={17} aria-hidden="true" /> : <Moon size={17} aria-hidden="true" />}
    {!compact && <span>{label}</span>}
  </button>
}
